import React from 'react';
import SimpleTabs from '../../../components/tabs/simpleTabs';
import { TabInterface } from '../../../interfaces/simpleTabs.interface';

const tabs: TabInterface[] = [

  {
    tabLabel: 'tokensDeveloper',
    href: '/developers/tokens/developer',
    identifierName: 'tokensDeveloper',
  },
  {
    tabLabel: 'tokensSessions',
    href: '/developers/tokens/sessions',
    identifierName: 'tokensSessions',
  },
];

const TokensPage = () => (
  <div className="w-full">
    <SimpleTabs tabs={tabs} />
  </div>
);

export default TokensPage;
